import { Controller } from "@hotwired/stimulus"
import { showBlock } from "lib/helpers"

// Analytics tab controller for _edit_analytics partial.
// Handles: statistics chart, unanswered questions report generate/destroy.
export default class extends Controller {
  static values = {
    errorBlock: { type: String, default: "#chatbot-errors" },
  }

  connect() {
    this.statsChart = {}
    this.addAssistantStatisticChart()
    this.initAssistantStatistic()
    this.initGenerateUnansweredQuestionsReport()
    this.initDestroyUnansweredQuestionsReport()
  }

  disconnect() {
    if (this.statsChart && typeof this.statsChart.destroy === 'function') { this.statsChart.destroy() }
    this.statsChart = {}
  }

  addAssistantStatisticChart() {
    const canvas = document.getElementById("unanswered-question-chart")
    if (!canvas) return
    if (this.statsChart && typeof this.statsChart.destroy === 'function') { this.statsChart.destroy(); this.statsChart = {} }
    else { const existing = (typeof Chart !== 'undefined' && Chart.getChart) ? Chart.getChart(canvas) : null; if (existing) existing.destroy() }
    this.statsChart = new Chart(canvas, {
      type: 'bar',
      data: {
        labels: [],
        datasets: [
          { data: [], borderColor: '#3978FC', backgroundColor: '#3978FC', borderWidth: 1, label: "received" },
          { data: [], borderColor: '#9DBDFF', backgroundColor: '#9DBDFF', borderWidth: 1, label: "not answered" }
        ]
      },
      options: { responsive: true, plugins: { legend: { display: false } }, scales: { y: { beginAtZero: true, suggestedMax: 10, min: 0, ticks: { stepSize: 1 } } } }
    })
  }

  initAssistantStatistic() {
    const canvas = document.getElementById("unanswered-question-chart")
    if (!canvas || !page_args.assistant_statistic_path) return
    const self = this
    $.ajax({
      url: page_args.assistant_statistic_path, type: "GET", dataType: "JSON",
      success(response) {
        if (response.success) {
          const data = response.data
          self.statsChart.data.labels = data.labels
          self.statsChart.data.datasets[0].data = data.total_questions
          self.statsChart.data.datasets[1].data = data.unanswered_questions
          self.statsChart.update()
          $("#total-received-messages").html(data.total_received_messages)
          $("#not-answered-percent").html(data.percentage_not_answered + "%")
        }
      }
    })
  }

  initGenerateUnansweredQuestionsReport() {
    const self = this
    $("#unanswered-questions-link").on('click.editAnalytics', function (e) {
      e.preventDefault()
      $.ajax({
        url: this.href, type: "POST", dataType: "JSON",
        beforeSend() {
          const icon = document.createElement('span'); icon.classList.add('icon-reload', 'icon')
          const text = document.createElement("span"); text.classList.add('gray', 'wait-generation'); text.innerText = "Generating..."
          $(".unanswered_questions-control-wrap").html(text).append(icon)
        },
        success(response) {
          if (response.success) { if (response.report.status === "processing") setTimeout(() => self.getReportStatus(), 2000); else self.setUnansweredQuestionsReportState(response.report) }
          else { const error = $(self.errorBlockValue); if (error.length === 1) error.after(error.clone()); showBlock(self.errorBlockValue, response.message) }
        },
        error() { showBlock(self.errorBlockValue, "An error occurred during request.") }
      })
    })
  }

  initDestroyUnansweredQuestionsReport() {
    const self = this
    $("#remove-unanswered-questions-link").on('click.editAnalytics', function (e) {
      e.preventDefault()
      $.ajax({
        url: this.href, type: "DELETE", dataType: "JSON",
        beforeSend() { const text = document.createElement("span"); text.classList.add('gray'); text.innerText = "Removing old report..."; $(".unanswered_questions-control-wrap").html(text) },
        success(response) {
          if (response.success) {
            const link = document.createElement('a'); link.href = page_args.unanswered_questions_report_path; link.id = "unanswered-questions-link"; link.textContent = "Generate unanswered questions report"
            $(".unanswered_questions-control-wrap").html('').append(link)
            self.initGenerateUnansweredQuestionsReport()
          } else { const error = $(self.errorBlockValue); if (error.length === 1) error.after(error.clone()); showBlock(self.errorBlockValue, response.message) }
        },
        error() { showBlock(self.errorBlockValue, "An error occurred during request.") }
      })
    })
  }

  getReportStatus() {
    const self = this
    $.ajax({
      url: page_args.unanswered_questions_report_path, method: "GET", dataType: "json",
      success(response) { if (response.success) { if (response.report.status === "processing") setTimeout(() => self.getReportStatus(), 2000); else self.setUnansweredQuestionsReportState(response.report) } else showBlock(self.errorBlockValue, response.message) },
      error() { showBlock(self.errorBlockValue, "An error occurred during request") }
    })
  }

  setUnansweredQuestionsReportState(report) {
    const self = this
    switch (report.status) {
      case 'processing': $(".unanswered_questions-control-wrap").html("Generating..."); break
      case 'fail': $(".unanswered_questions-control-wrap").html("Something went wrong!"); break
      case 'complete': {
        const docIcon = document.createElement('div'); docIcon.classList.add('icon-doc', 'file-icon')
        const filename = document.createElement('div'); filename.classList.add('filename'); filename.innerHTML = report.filename
        const downloadBtn = document.createElement('a'); downloadBtn.classList.add('new-btn'); downloadBtn.href = report.url; downloadBtn.textContent = "Download"
        const iconTrash = document.createElement("span"); iconTrash.classList.add('icon-trash')
        const removeBtn = document.createElement('a'); removeBtn.href = page_args.unanswered_questions_report_path; removeBtn.id = 'remove-unanswered-questions-link'; removeBtn.appendChild(iconTrash)
        const wrapper = document.createElement('div'); wrapper.classList.add('unanswered-question-filename')
        wrapper.appendChild(docIcon); wrapper.appendChild(filename); wrapper.appendChild(removeBtn)
        $(".unanswered_questions-control-wrap").html('').append(wrapper).append(downloadBtn)
        self.initDestroyUnansweredQuestionsReport()
        break
      }
    }
  }
}
